export const API_URL = "/api";
export const RECOVER_PASSWORD_URL = "https://api.sportmin.com/api/v1/login/recovery";
